import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import PlayerService from 'src/service/PlayerService'
import ToastComponent from 'src/components/common/TaostComponent'

const ChangeTeamModal = ({ visible, onClose, playerIds, teamList, onSuccess }) => {
  const [team, setTeam] = useState('')
  const [touched, setTouched] = useState(false)
  const [loader, setLoader] = useState(false)

  const handleClose = () => {
    setTeam('')
    setTouched(false)
    onClose()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setTouched(true)
    if (!team) return
    setLoader(true)
    PlayerService.bulkUpdateTeam({ player_ids: playerIds, team })
      .then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          onSuccess()
          handleClose()
        } else {
          ToastComponent(res.message, 'error')
        }
        setLoader(false)
      })
      .catch(() => {
        ToastComponent('Something went wrong', 'error')
        setLoader(false)
      })
  }

  return (
    <CModal visible={visible} onClose={handleClose}>
      <CForm onSubmit={handleSubmit}>
        <CModalHeader>
          <CModalTitle>Change Team</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="text-medium-emphasis mb-3">
            Update team for {playerIds.length} selected player{playerIds.length !== 1 ? 's' : ''}.
          </div>
          <CCol>
            <CFormLabel htmlFor="change-team">Team</CFormLabel>
            <CFormSelect
              id="change-team"
              className={!team && touched ? 'is-invalid' : ''}
              value={team}
              onChange={(e) => setTeam(e.target.value)}
            >
              <option value="">Select Team</option>
              {teamList.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
            </CFormSelect>
            {!team && touched && <CFormFeedback invalid>Team is required</CFormFeedback>}
          </CCol>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={handleClose}>
            Cancel
          </CButton>
          <CLoadingButton type="submit" color="primary" loading={loader}>
            Update {playerIds.length} Player{playerIds.length !== 1 ? 's' : ''}
          </CLoadingButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default ChangeTeamModal
